<div class="w-full h-px bg-navy-50"></div>
<span [class]="titleClasses" (click)="titleClicked.emit()">
  {{ title }}
</span>
<div class="w-full h-px bg-navy-50"></div>
